import { bridge, initCoverage } from '@/common';
import '@/styles/font.less';
import '@/styles/indexV2.less';
import init from '../initSPA';
import IndexV2 from './IndexV2.vue';
import { ehcDspPage, pageShow } from '@/common/pgyCollect/dspUtil';

(window as any).haveReportedTTI = false;
bridge.setBounces(0);

initCoverage();

Promise.all([ehcDspPage(), initPage()])
  .then((res) => {})
  .catch(() => {})
  .finally(() => {
    pageShow();
  });

function initPage() {
  const routes = [
    {
      path: '/',
      name: 'index',
      component: IndexV2,
      meta: {
        keepAlive: true,
      },
    },
  ];
  init(routes);
}
